import React from 'react'

const Gallery = () => {
    return (
        <>

            <section id='gallery'>
                <div className="container-fluid">
                    <div className="CommonPadding">
                        <div className="row d-flex justify-content-center align-items-center Organic-Food-Section-Main-Heading-Top">
                            <div className='Home-Our-Services-Section-Title'>
                                <h5>
                                    Gallery
                                </h5>
                                <h2 style={{ lineHeight: "1.7", fontSize: "17px" }}>
                                    ✨ Personality According Style — because beauty begins with confidence.
                                </h2>
                            </div>
                        </div>

                        <div className="row g-4">
                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img src={require("../Img/A1.jpg")} alt="" />
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img src={require("../Img/A2.jpg")} alt="" />
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img src={require("../Img/A3.jpg")} alt="" />
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img src={require("../Img/A4.jpg")} alt="" />
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img src={require("../Img/A5.jpg")} alt="" />
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img src={require("../Img/A6.jpg")} alt="" />
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img src={require("../Img/A7.jpg")} alt="" />
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                <div className="AboutInfoTop">
                                    <img src={require("../Img/A8.jpg")} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Gallery